module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_36.dot-b436c3dfba8ad351f856fcd4298c00e2.svg";